import React from 'react';

const Volleyball = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g id='Volleyball' transform='translate(-56.502 -487.559)'>
                <path
                    id='Path_3128'
                    data-name='Path 3128'
                    d='M62.511,500.3l-.651-.07a.152.152,0,0,1-.131-.1,6.61,6.61,0,0,1-.426-.947,13.055,13.055,0,0,1-.575-2.267c-.074-.437-.133-.878-.193-1.32l-.071-.52s.351.037.521.054q.644.058,1.29.111l.237.017c.112.008.223.016.335.028.026.085.071.19.116.3C63.432,496.7,64,498,64.633,499.28c.09.179.185.355.28.531l.08.149a6.942,6.942,0,0,1-1.84.333l-.07.012Z'
                    transform='translate(0.661 1.254)'
                />
                <path
                    id='Path_3129'
                    data-name='Path 3129'
                    d='M64.338,498.265a12.474,12.474,0,0,0,3.568-3.988,16.633,16.633,0,0,0,1.071-2.164,6.444,6.444,0,0,1,.206,1.283l.009.085,0,.627-.041.418a6.813,6.813,0,0,1-.828,2.634,7.026,7.026,0,0,1-3.047,2.911l-.018.008Z'
                    transform='translate(1.306 0.759)'
                />
                <path
                    id='Path_3130'
                    data-name='Path 3130'
                    d='M66.391,489.954a6.558,6.558,0,0,0-2.215-1.157,15.461,15.461,0,0,0-2.3-.549c-.465-.078-.96-.14-1.562-.195a6.491,6.491,0,0,1,1.5-.407l.643-.086.505,0,.37.023a6.878,6.878,0,0,1,3.489,1.205l.141.094-.537,1.1Z'
                    transform='translate(0.635 0)'
                />
                <path
                    id='Path_3131'
                    data-name='Path 3131'
                    d='M57.362,496.866a6.752,6.752,0,0,1-.791-2.34c-.019-.134-.034-.268-.048-.4l-.021-.182.518.317c.065.039.133.075.2.107l-.033.312c0,.326,0,.651.016.974.02.342.072.682.125,1.021C57.33,496.671,57.356,496.832,57.362,496.866Z'
                    transform='translate(0 1.064)'
                />
                <path
                    id='Path_3132'
                    data-name='Path 3132'
                    d='M65.13,492.532a6.747,6.747,0,0,0-1.568-.659,17.223,17.223,0,0,0-2.506-.534c-.888-.131-1.806-.223-2.808-.279L57.23,491a7.5,7.5,0,0,1,1.926-2.225.155.155,0,0,1,.11-.044c.964.054,1.684.114,2.351.2a13.809,13.809,0,0,1,2.975.664,5.709,5.709,0,0,1,1.549.793,3.759,3.759,0,0,1,.3.266l.034.031-1.092,2.009C65.3,492.638,65.215,492.583,65.13,492.532Z'
                    transform='translate(0.121 0.196)'
                />
                <path
                    id='Path_3133'
                    data-name='Path 3133'
                    d='M62.935,494.863c-.247-.018-.495-.035-.741-.06-.5-.048-1-.1-1.494-.17-.519-.077-1.035-.177-1.549-.285a8.053,8.053,0,0,1-1.379-.4,4.525,4.525,0,0,1-.729-.408s-.446-.3-.512-.342a6.311,6.311,0,0,1,.271-1.353l.11-.341.891.044c.289.013.578.024.865.051q1.111.1,2.22.23a15.844,15.844,0,0,1,2.025.378,6.909,6.909,0,0,1,1.694.625c.106.061.208.128.309.2l.081.052a13.092,13.092,0,0,1-1.205,1.716.273.273,0,0,1-.226.117S63.132,494.877,62.935,494.863Z'
                    transform='translate(0.005 0.657)'
                />
                <path
                    id='Path_3134'
                    data-name='Path 3134'
                    d='M63.279,495.893a11.044,11.044,0,0,0,1.492-2.045c.78-1.287,1.468-2.607,2.26-4.194l.2-.4A7.655,7.655,0,0,1,68.558,491a.341.341,0,0,1,.024.293,14.385,14.385,0,0,1-1.417,3.118,12.619,12.619,0,0,1-2.053,2.586,9.374,9.374,0,0,1-1.006.842Z'
                    transform='translate(1.13 0.282)'
                />
                <path
                    id='Path_3135'
                    data-name='Path 3135'
                    d='M60.959,500a6.81,6.81,0,0,1-.7-.291,7.019,7.019,0,0,1-1.532-.977.5.5,0,0,1-.154-.233,15.076,15.076,0,0,1-.553-2.315,8.354,8.354,0,0,1-.12-1.332c0-.09.008-.18.015-.269.5.121,1,.238,1.509.355l.254.06c.086.02.173.04.26.051a3.536,3.536,0,0,0,.032.669,18.062,18.062,0,0,0,.974,4.244Z'
                    transform='translate(0.233 1.17)'
                />
            </g>
        </svg>
    );
};

export default Volleyball;
